/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import { resetEditBeneficiary } from "../../../../../redux/features/accounts/BeneficiaryAccount/createAccount";

import ICONS from "../../../../../assets/Icons";
import CommonToast from "../../../../../components/_utils/CommonToast";
import SVGComponent from "../../../../../components/_utils/SVGComponent";
import {
  editReimbursementAccount,
  viewAccountDetail,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import {
  beneLookUp,
  resetBeneData,
  resetPANVerification,
  verifyThisPAN,
} from "../../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import ReimbursementPanDetails from "../../ReimbursementPanDetails";

const ReimbursementEditPan = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [showAction, setShowAction] = useState(false);
  const [test, setTest] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [alreadyLinked, setAlreadyLinked] = useState(false);
  const [nonArchive, setNonArchive] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [accountType, setAccountType] = useState({ type: "", id: "" });
  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [shutViewAll, setShutViewAll] = useState(false);
  const [isAchived, setIsArchived] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isDennied, setIsDennied] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [newMessage, setNewMessage] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [hideCreate, setHideCreate] = useState(false);
  const [hideBlock, setHideBlock] = useState(false);
  const [previousBankNo, setPreviousBankNo] = useState("");
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    newGstValue: "",
  });
  const [updateActive, setUpdateActive] = useState(false);
  const [updatedGst, setUpdatedGst] = useState({
    id: "",
    panNo: "",
    gstNo: "",
  });
  const [associatedPan, setAssociatedPan] = useState(true);

  const [GSTPanExist, setGSTPanExist] = useState(false);
  const [openPopEditCheck, setOpenPopEditCheck] = useState(false);
  const verifyDebounceRef = useRef(null);
  const retryCountRef = useRef(0);
  const pendingVerifyPanRef = useRef(null);
  const abortControllerRef = useRef(null);
  const VERIFY_DEBOUNCE_MS = IntervalConfiguration.intervalTiny;

  const {
    verifyPAN,
    beneLookData,
    beneLookLoading,
    verifyPANisLoading,
    viewAccountDetailData,
    beneLookError,
    viewAccountDetailLoading,
  } = useSelector((state) => state.verify);
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(1);

  const { reimbursementAccountEditData } = useSelector(
    (state) => state.ReimburseAccount,
  );

  useEffect(() => {
    if (!verifyPANisLoading) {
      if (
        pendingVerifyPanRef.current != null &&
        payload.panNumber !== pendingVerifyPanRef.current
      ) {
        return;
      }
      const isCurrentPanFullLength =
        payload.panNumber?.length === GlobalConfiguration.panLength;
      if (verifyPAN?.status === true) {
        if (isCurrentPanFullLength) {
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;
          setVerifiedPan(true);

          if (services?.includes("RUAccount") || services?.includes("Admin")) {
            dispatch(beneLookUp({ pan_number: payload.panNumber }));
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "RUAccount" },
            });
          }

          setPayload({
            ...payload,
            legalName: verifyPAN?.pan_details?.full_name,
          });
        }
      } else if (verifyPAN?.status === false) {
        if (isCurrentPanFullLength) {
          setVerifiedPan(false);
          setPayload({
            ...payload,
            gstin: "",
          });
        }
      }
    }
  }, [verifyPAN]);

  useEffect(() => {
    let gstStoredData = sessionStorage.getItem("PAN GST Edit NewValue");
    if (!beneLookLoading && beneLookData?.status) {
      if (allData?.length === GlobalConfiguration.lengthCheckZero) {
        setAllData((allData) => [
          ...allData,
          ...beneLookData?.beneficiary_accounts,
        ]);

        const totalRecords = beneLookData?.title?.records ?? 0;
        const firstPageLength = beneLookData?.beneficiary_accounts?.length ?? 0;
        if (
          totalRecords > firstPageLength &&
          (services?.includes("RUAccount") || services?.includes("Admin"))
        ) {
          setPage(2);
          dispatch(beneLookUp({ pan_number: payload.panNumber, page: 2 }));
        }

        if (beneLookData?.title?.records > allData?.length) {
          setTest(false);
        } else {
          setTest(true);
        }
      } else if (beneLookData?.title?.records > allData?.length) {
        const totalRecords =
          beneLookData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
        const newAccounts = beneLookData?.beneficiary_accounts ?? [];
        const currentLength =
          allData?.length ?? GlobalConfiguration.lengthCheckZero;
        const willHaveAll = currentLength + newAccounts.length >= totalRecords;

        setAllData((allData) => [...allData, ...newAccounts]);

        if (
          !willHaveAll &&
          (services?.includes("RUAccount") || services?.includes("Admin"))
        ) {
          const nextPage = page + GlobalConfiguration.lengthCheckOne;
          dispatch(
            beneLookUp({
              pan_number: payload.panNumber,
              page: nextPage,
            }),
          );
          setPage((prevPage) => prevPage + GlobalConfiguration.lengthCheckOne);
        } else if (!willHaveAll) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "RUAccount" },
          });
        }
        setTest(false);
      }
      allData?.forEach((val) => {
        if (val?.id === id) {
          setPayload({
            ...payload,
            gstin:
              gstStoredData != null ? gstStoredData : val?.gstin_detail || "",
          });
        }
      });
    }

    if (
      allData &&
      !beneLookLoading &&
      allData?.length === beneLookData?.title?.records
    ) {
      const hasId = allData.some((val) => val?.id === id);
      setAssociatedPan(hasId);
    } else if (!beneLookLoading && beneLookError && !allData) {
      BenEnableNextButton(false);
      setAssociatedPan(false);
    }

    if (haveLinkNew && !beneLookLoading) {
      setIsLinkedAccount(true);
    } else if (
      haveLinkNew === undefined ||
      (haveLinkNew === false && !beneLookLoading)
    ) {
      setNewMessage(false);
    }
  }, [beneLookData, id, beneLookError]);

  const handleNext = () => {};

  const handleBack = () => {
    if (nextButtonEnabled && !openPopEditCheck) {
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
      );
    } else if (openPopEditCheck) {
      setOpenPopEdit(true);
    } else {
      setOpenPopEdit(true);
    }
  };

  useEffect(() => {
    const fetchPANData = async () => {
      let response = await dispatch(viewAccountDetail({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANData();
  }, [dispatch, id, navigate]);

  let haveLinkNew = allData?.some((val) => {
    return val?.bank_acc_no === previousBankNo && val?.id !== id;
  });

  useEffect(() => {
    sessionStorage.setItem("Pan Gst Verification", JSON.stringify(updatedGst));
  }, [updatedGst]);

  useEffect(() => {
    setIsFocus(true);
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      setUpdatedGst({
        id: viewAccountDetailData?.reimbursement_accounts[0]?.id,
        panNo: viewAccountDetailData?.reimbursement_accounts[0]?.pan_no,
        gstNo: viewAccountDetailData?.reimbursement_accounts[0]?.gstin_detail,
      });
      setPayload({
        ...payload,
        panNumber: viewAccountDetailData?.reimbursement_accounts[0]?.pan_no,
        gstin: viewAccountDetailData?.reimbursement_accounts[0]?.gstin_detail,
      });

      if (services?.includes("RUAccount") || services?.includes("Admin")) {
        dispatch(
          verifyThisPAN({
            pan_number:
              viewAccountDetailData?.reimbursement_accounts[0]?.pan_no,
            navigate: navigate,
            showToast: false,
          }),
        );
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [viewAccountDetailData]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "PAN details",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled:
        (isLinkedAccount || alreadyLinked) && verifiedPan
          ? nextButtonEnabled
          : !nextButtonEnabled && !updateActive,
      nextHoverOption: "black",
    },
  ];

  const handleUpdateAccount = () => {
    if (updateActive) return;

    setUpdateActive(true);

    dispatch(
      editReimbursementAccount({
        id: id,
        pan: payload.panNumber,
        name: payload?.legalName,
        gstin: payload?.gstin,
        navigate,
      }),
    );
    setAccountType({ type: "", id: "" });
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
  };

  useEffect(() => {
    if (reimbursementAccountEditData?.status === true) {
      const prev = viewAccountDetailData?.reimbursement_accounts?.[0];
      const updatedFields = [];
      if (prev?.pan_no !== payload.panNumber) updatedFields.push("pan_no");
      if ((prev?.gstin_detail || "") !== (payload.gstin || ""))
        updatedFields.push("gstin_detail");
      const fieldsToPass =
        updatedFields.length > GlobalConfiguration.lengthCheckZero
          ? updatedFields
          : ["pan_no", "gstin_detail"];
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/pan_edit_success/${id}`,
        {
          state: { updatedFields: fieldsToPass },
          replace: true,
        },
      );
      localStorage.setItem("haveAssociated", JSON.stringify(beneLookError));
      dispatch(resetEditBeneficiary());
    }
  }, [reimbursementAccountEditData]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.id === id) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("RUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (inputPan?.length < GlobalConfiguration.panLength) {
      setOpenPopEditCheck(true);
    }
    if (panRegex.test(inputPan)) {
      setOpenPopEditCheck(true);
    }
    if (viewAccountDetailData?.reimbursement_accounts[0]?.pan_no === inputPan) {
      setOpenPopEditCheck(false);
    }

    if (!specialRegex.test(inputPan)) {
      return;
    }

    if (inputPan?.length > GlobalConfiguration.panLength) {
      return;
    }
    if (
      !panRegex.test(inputPan) &&
      inputPan?.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetBeneData());
      setPayload({
        ...payload,
        gstin: "",
      });
    } else if (inputPan?.length === GlobalConfiguration.panLength) {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }
      if (panRegex.test(inputPan)) {
        dispatch(resetPANVerification());
        setVerifiedPan(null);
        verifyDebounceRef.current = setTimeout(() => {
          verifyDebounceRef.current = null;
          abortControllerRef.current?.abort();
          abortControllerRef.current = new AbortController();
          pendingVerifyPanRef.current = inputPan;
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;

          if (services?.includes("RUAccount") || services?.includes("Admin")) {
            dispatch(
              verifyThisPAN({
                pan_number: inputPan,
                navigate: navigate,
                signal: abortControllerRef.current.signal,
                showToast: false,
              }),
            );
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "RUAccount" },
            });
          }
        }, VERIFY_DEBOUNCE_MS);
      }
      setAllData([]);
    } else {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }
      retryCountRef.current = GlobalConfiguration.lengthCheckZero;
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
      setAccountType({ type: "", id: "" });

      setShowAccInfo(false);
      sessionStorage.removeItem("PAN GST Edit NewValue");
    }

    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: "",
    });
    setAccountType({ type: "", id: "" });
    setIsLinkedAccount(false);
    setNewMessage(false);
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
    setIsBlock(false);
    setDisableCreateNext(false);
    setIsActive(false);
    setHideBlock(false);
    setHideCreate(false);
    setNonArchive(false);
    setAlreadyLinked(false);
  };

  const handleConfirm = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };

  return (
    <div className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-hidden h-screen">
      <div className="min-h-navbar-breadcrumb-height hidden Qsmd:block"></div>
      <div
        className={`edit_pan_con_main ${!beneLookLoading && verifiedPan === true ? "" : " h-full-height"} lg:h-full-height bg-primary-bg overflow-y-auto`}
        style={{
          // Not sure which one to keep
          // height:
          //   unachivedOpenPop || achivedOpenPop || showRejectTnxPopup
          //     ? "var(--full-height)"
          //     : "fit-content",
          overflowY:
            openPopEdit ||
            achivedOpenPop ||
            unachivedOpenPop ||
            showRejectTnxPopup
              ? "hidden"
              : "",
          height:
            openPopEdit ||
            achivedOpenPop ||
            unachivedOpenPop ||
            showRejectTnxPopup
              ? "var(--full-height)"
              : "",
        }}
      >
        {openPopEdit && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Are you sure you want to leave this page?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Leaving this page will exit you from current flow."
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => setOpenPopEdit(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleConfirm}
              btnTwoEnabledBgColor="var(--text-primary)"
              btnTwoEnabledTextColor="var(--primary-bg)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        <div className=" h-navbar-height block Qsmd:hidden"></div>
        <div className="!bg-primary-nav top_bar_btn_resp_edit block Qmd:hidden">
          <div className="h-stepper-height bg-primary-nav w-full flex shadow-box-shadow-bottom">
            <div
              className="w-icon-md h-icon-md m-margin-md"
              onClick={() => handleBack()}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                color={"var(--text-primary)"}
              />
            </div>
            <div className="py-padding-sm">
              <p className="text-text-primary text-font-md">
                Reimbursement Account
              </p>
              <p className="text-text-secondary text-font-xs">PAN details</p>
            </div>
          </div>
        </div>
        <div className="main_edit_stepper_div  z-z-index-toast hidden Qsmd:block">
          <div className="bene_crt_reminder_header flex justify-center items-end w-screen Qmd:relative fixed bottom-bottom-base left-left-base z-z-index-loader min-h-stepper-height">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
        </div>
        <div className="edit_pan_details_all mt-margin-md Qsmd:mt-margin-base Qlg:overflow-hidden  lg:h-full-height overflow-y-auto hidden w-full">
          <ReimbursementPanDetails
            showAccInfo={showAccInfo}
            allData={allData}
            setShowAccInfo={setShowAccInfo}
            associatedPan={associatedPan}
            test={test}
            gstin={payload?.gstin}
            panNumber={payload.panNumber}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={verifyPAN?.pan_details}
            beneLookData={beneLookData}
            beneLookLoading={beneLookLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={verifyPANisLoading}
            isAchived={isAchived}
            setIsArchived={setIsArchived}
            setIsApproved={setIsApproved}
            isApproved={isApproved}
            handleNext={handleNext}
            accountType={accountType}
            setAccountType={setAccountType}
            isDennied={isDennied}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            isPending={isPending}
            nextButtonEnabled={nextButtonEnabled}
            shutViewAll={shutViewAll}
            setShutViewAll={setShutViewAll}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            panLatestData={payload.panNumber}
            isFocus={isFocus}
            setIsFocus={setIsFocus}
            type={"editFlow"}
            showAction={showAction}
            setShowAction={setShowAction}
            previousId={id}
            setIsBlock={setIsBlock}
            isBlock={isBlock}
            isActive={isActive}
            setIsActive={setIsActive}
            setNewMessage={setNewMessage}
            newMessage={newMessage}
            beneLookError={beneLookError}
            setHideBlock={setHideBlock}
            setHideCreate={setHideCreate}
            hideBlock={hideBlock}
            hideCreate={hideCreate}
            setNonArchive={setNonArchive}
            nonArchive={nonArchive}
            previousBankNo={previousBankNo}
            setPreviousBankNo={setPreviousBankNo}
            isLinkedAccount={isLinkedAccount}
            setIsLinkedAccount={setIsLinkedAccount}
            unachivedOpenPop={unachivedOpenPop}
            setUnachivedOpenPop={setUnachivedOpenPop}
            achivedOpenPop={achivedOpenPop}
            setAchivedOpenPop={setAchivedOpenPop}
            alreadyLinked={alreadyLinked}
            setAlreadyLinked={setAlreadyLinked}
            haveLinkNew={haveLinkNew}
            setPayload={setPayload}
            payload={payload}
            setGSTPanExist={setGSTPanExist}
            GSTPanExist={GSTPanExist}
            showRejectTnxPopup={showRejectTnxPopup}
            setRejectTxnPopup={setRejectTxnPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default ReimbursementEditPan;
